import {LauncherBridge} from '../launcherBridge';

const launcherWeb: LauncherBridge = {
    getAccessToken: async (): Promise<string> => 'NA',
    requestSignIn: async (): Promise<void> => undefined,
    isSSOEnabled: async (): Promise<boolean> => false,
    setSSOEnabled: async (): Promise<void> => undefined
};

export default launcherWeb;
